import { render, staticRenderFns } from "./ImageCategories.vue?vue&type=template&id=ee189e74&scoped=true&"
import script from "./ImageCategories.vue?vue&type=script&lang=js&"
export * from "./ImageCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee189e74",
  null
  
)

export default component.exports